"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const STORAGE_KEYS_1 = __importDefault(require("../../../constants/app/STORAGE_KEYS"));
/**
 * Returns the payment token if cookie exists
 * Should run on client side
 * @returns {string} token if exists
 * @returns {undefined} if cookie does not exist
 */
function getPaymentToken() {
    return js_cookie_1.default.get(STORAGE_KEYS_1.default.PAYMENT_COOKIE);
}
exports.default = getPaymentToken;
